<template>
  <div class="containersView">
    <aside class="filtersWrapper">
      <div class="containersFilters">
        <div class="headerText">
          FILTER CONTAINERS
        </div>
        <div class="garbClsContainer">
          <div class="garbClsHeader">
            Garbage Class:
          </div>
          <div class="garbClsTypes">
            <article>
              <section class="garbClsOption">
                <input type="checkbox" id="plasticCheck" name="plastic" value="plastic" class="garbClsCheckbox" v-model="fPlastic">
                <label for="plasticCheck">Plastic</label>
              </section>
              <section class="garbClsOption">
                <input type="checkbox" id="organicCheck" name="organic" value="organic" class="garbClsCheckbox" v-model="fOrganic">
                <label for="organicCheck">Organic</label>
              </section>
              <section class="garbClsOption">
                <input type="checkbox" id="paperCheck" name="paper" value="paper" class="garbClsCheckbox" v-model="fPaper">
                <label for="paperCheck">Paper</label>  
              </section>
            </article>
          </div>
        </div>
        <div class="garbClsContainer">
          <div class="garbClsHeader">
            Capacity
          </div>
          <div class="garbClsTypes">
            <article>
              <section class="garbClsOption">
                <input type="checkbox" id="full" name="full" value="full" class="garbClsCheckbox" v-model="fFull">
                <label for="full">Full</label>
              </section>
              <section class="garbClsOption">
                <input type="checkbox" id="halfFull" name="halfFull" value="halfFull" class="garbClsCheckbox" v-model="fHalfFull">
                <label for="halfFull">Half-full</label>
              </section>
              <section class="garbClsOption">
                <input type="checkbox" id="empty" name="empty" value="empty" class="garbClsCheckbox" v-model="fEmpty">
                <label for="empty">Empty</label>
              </section>
            </article>
          </div>
        </div>
        <div class="garbClsContainer">
          <div class="garbClsHeader">
            Search by serial number
          </div>
          <div class="searchInputContainer">
            <input type="number" id="searchNumber" name="searchNumber" placeholder="0" min="0" class="containerInput" v-model="fQuery">
          </div>
        </div>
      </div>
    </aside>
    <div class="containersList">
      <v-btn v-if="simulationStart == false"
        class="ma-2 pa-2 mx-auto"
        color="success"
        small
        depressed
        rounded
        @click="simulationStart = !simulationStart"
      >
        Initiate simulation
      </v-btn>
      <v-btn v-else
        class="ma-2 pa-2 mx-auto"
        color="error"
        small
        depressed
        rounded
        @click="simulationStart = !simulationStart"
      >
        Stop simulation
      </v-btn>
      <div class="containersBox">
        <ContainerDetail v-for="item in filteredContainers" :container="item" :key="item.serialNumber" v-on:showModal="displayModal"/>
      </div>
    </div>
    
  </div>
</template>
  
<script>
import ContainerDetail from './ContainerDetail.vue';
import containersGarbageIIOTAPI from '@/services/containersGarbageIIOTAPI';
import ContainerModal from '../../../views/scenarios/iiot/ContainerDetailView.vue';
import axios from 'axios';
export default {
  name: "ContainerCards",
  components: {
    ContainerDetail
  },
  data() {
    return {
      start: true,
      simulationStart: false,
      items: [ ],
      fPlastic: false,
      fOrganic: false,
      fPaper: false,
      fFull: false,
      fHalfFull: false,
      fEmpty: false,
      fQuery: 0,
      route: []
    };
  },
  computed: {
    filteredContainers() {
      let tempCont = this.items;
      let allTypes = this.fPlastic && this.fOrganic && this.fPaper;
      let allCapacities = this.fFull && this.fHalfFull && this.fEmpty;
      if(allTypes) {
        tempCont = this.items;
      }

      if(allCapacities) {
        tempCont = this.items;
      }

      tempCont = tempCont.filter((item) => {

        if(!allTypes) {
          if(this.fPlastic && item.garbageClass == "plastic") {
            return item;
          }

          if(this.fOrganic && item.garbageClass == "organic") {
            return item;
          }

          if(this.fPaper && item.garbageClass == "paper") {
            return item;
          }
        }

        if(!allCapacities) {
          let itmCapacity = (item.capacity/item.totalCapacity) * 100;

          if(this.fFull && itmCapacity >= 95) {
            return item;
          }

          if(this.fHalfFull && itmCapacity >= 45 && itmCapacity < 75) {
            return item;
          }

          if(this.fEmpty && itmCapacity < 5) {
            return item;
          }
        }

        if(this.fQuery && item.serialNumber == this.fQuery) {
          return item;
        }

      });

      if(tempCont.length == 0) {
        /*this.$toasted.show("No containers found", {
          theme: "bubble",
          position: "top-center",
          duration: 3000,
          type: "error",
        });*/ //TODO: Toasted not working due to lifecycle issues (I think)
        
        tempCont = this.items;
      }

      return tempCont;
    }
  },
  mounted() {
    this.getContainers();
  },
  methods: {
    getContainers() {
      containersGarbageIIOTAPI.get('/property/containersDetails').then((response) => {
        this.items = response.data;
        var a = 0;
        var l = [];
        this.items.forEach((it) => {
          if(a > 5)return;
          l.push([parseFloat(it.location.lng), parseFloat(it.location.lat)]);
          a++;
          
        })
        l.push([-2.40554, 36.83159])
        l.push([-2.40554, 36.83159])
        axios.post('https://api.openrouteservice.org/v2/directions/driving-car/geojson', { "coordinates": l}, { headers: { "Authorization":"5b3ce3597851110001cf6248adf04012457b435eb96311273855bb53", "Content-Type": "application/json", "Accept": "application/json, application/geo+json, application/gpx+xml, img/png; charset=utf-8" }}).then((res) => {
          
          res.data.features[0].geometry.coordinates.forEach((it) => {
            it.reverse();
          })
          this.route = res.data.features[0].geometry;
          console.log(this.route);
        })


        
      })
    },
    displayModal() {
      this.showModal = !this.showModal;
    }
  },
};
</script>

<style>
.containersView {
  display: grid;
  grid-template-columns: 1fr 6fr;
}

.containersFilters {
  display: grid;
  place-items: center;
  width: 100%;
}

.containersList {
  display: grid;
  place-items: center;
  margin: 1rem;
}
.containersBox {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  place-items:center;
  width: 100%;
  gap: 1rem;
  padding: 1rem;
}

.filtersWrapper{
  height: 100%;
  background-color: #DDDFE3;
  border-right: 1px solid #BBB;
}

.headerText {
  font-weight: 600;
  font-size: 1.2rem;
  color:#F6F6F6;
  margin: 1rem;
  background-color: #B0B5BF;
  height: 100%;
  width: 100%;
  display: grid;
  place-items: center;
}

.garbClsContainer {
  display: grid;
  place-items: center;
  width: 100%;
  background-color: #D9D9D9;
  color: #63635B;
  font-weight: 500;
  border-bottom: 1px solid #BBB;
}

.garbClsTypes {
  background-color: #C6C6C6;
  display: grid;
  place-items: center;
  width: 100%;
  height: 100%;
  margin: 0.5em 0;
}

.garbClsCheckbox {
  appearance: none;
  background-color: #D9D9D9;
  border: 0.15em solid #F6F6F6;
  height: 1.15em;
  width: 1.15em;
  border-radius: 0.15em;
  display: grid;
  place-content: center;
}

.garbClsCheckbox::before {
  content: "";
  width: 0.65em;
  height: 0.65em;
  transform: scale(0);
  transition: 120ms transform ease-in-out;
  box-shadow: inset 1em 1em var(#D9D9D9);
}

.garbClsCheckbox:checked::before {
  transform: scale(1);
  background-color: #F6F6F6;
}

.garbClsHeader {
  font-size: 1.1rem;
}

.garbClsOption {
  display: grid;
  grid-template-columns: 1fr 5fr;
  place-items: center;
  width: 100%;
}

.searchInputContainer {
  background-color: white;
  border-radius: 24px;
  margin-bottom: 10px;
  text-align: start;
  display: grid;
  place-items: center;
  padding-left: 10px;
  height: 80%;
  width: 80%;
}

.containerInput {
  font-weight: 500;
  -moz-appearance: textfield;
}

.containerInput::-webkit-inner-spin-button,
.containerInput::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>